import Hero from '../components/Hero';

const LandingPage = () => {
  return <Hero />;
};

export default LandingPage;
